// extracted by mini-css-extract-plugin
export default {"breedDropdownContainer":"BreedDropdown_breedDropdownContainer__KlsWC","breedDropdown":"BreedDropdown_breedDropdown__+a95t","dropdownIcon":"BreedDropdown_dropdownIcon__Oyq57"};